export abstract class BaseModel {
    abstract id: number;

    toJson(): Record<string, any> {
        return { ...this };
    }

    equals(other: BaseModel): boolean {
        return this.id === other.id && this.constructor === other.constructor;
    }
}

